export const FOLLOW_UP_STATUS = [
  "Pending",
  "Mobile",
  "Email",
  "walk-In",
  "Wrong Details",
  "Not Interested",
  "Registered",
];
